import { LINKS_WITH_SUB_NAVIGATION, INTERACTIVE_LINKS, INTERACTIVE_LINKS_MOBILE } from 'utils/constants';

export const isHasSubNavigation = (slug) => LINKS_WITH_SUB_NAVIGATION.includes(slug);

export const isHasSubSmallNavigation = (slug) => Object.keys(INTERACTIVE_LINKS).includes(slug);

export const isHasSubSmallNavigationMobile = (slug) => Object.keys(INTERACTIVE_LINKS_MOBILE).includes(slug);
